import axios from '@/lib/AxApi';

export default {
    async selectRow(params)
    {
        try
        {
            const response = await axios.get('/TherapyType/selectRow',
                {
                    params,
                });
            return response.data;
        }
        catch (e)
        {
            throw ({ error: true, notice: axios.errorHandler(e) });
        }
    },
    async submitData(params)
    {
        try
        {
            let func = 'insertRow';
            if (typeof params.id !== 'undefined' && params.id !== '')
            {
                func = 'updateRow';
            }

            const response = await axios.post(`/TherapyType/${func}`, params);
            return response.data;
        }
        catch (e)
        {
            throw ({ error: true, notice: axios.errorHandler(e) });
        }
    },
    async deleteRow(params)
    {
        try
        {
            const response = await axios.post('/TherapyType/deleteRow', params);
            return response.data;
        }
        catch (e)
        {
            throw ({ error: true, notice: axios.errorHandler(e) });
        }
    },
};
